// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__i3AZn","text":"SelectPayment_text__3NHwW","title":"SelectPayment_title__3TrxX","btn":"SelectPayment_btn__3TSSy"};